import { StateCreator } from 'zustand'

import { RootState, SentryState } from './types'

const initialState = {
  userId: '',
}

export const sentryStore: StateCreator<RootState, [], [], SentryState> = (set) => ({
  ...initialState,
  setUserId: (userId: string) => set({ userId }),
})
